import { render, staticRenderFns } from "./HiddenSelector.vue?vue&type=template&id=b45348e0&"
import script from "./HiddenSelector.vue?vue&type=script&lang=ts&"
export * from "./HiddenSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports